import { useSelector } from 'react-redux';

const useProgram = () => useSelector(state => state.programReducer.program);

const useCurrentStep = () => useSelector(state => state.programReducer.currentStep || 0);

const useUserPrograms = () => useSelector(state => state.programReducer.programs);

export { useProgram, useCurrentStep, useUserPrograms };
